import React, { PropsWithChildren } from 'react';

import { HttpClientFactory } from '../../httpClient';
import { HttpClientContext } from './HttpClientContext';

type HttpClientProviderProps = PropsWithChildren<{
  httpClient: HttpClientFactory;
}>;

export function HttpClientProvider({ httpClient, children }) {
  return <HttpClientContext.Provider value={httpClient}>{children}</HttpClientContext.Provider>;
}
